
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
import cresusFond from "../../assets/images/prop1.png"
import React, {useEffect, useState} from "react"
import APIS from "../../apis"
const Redirection = props => {
  const inscrit = async () => {
    props.history.push("/login1")
  }
  const exist = async () => {
    props.history.push("/CheckIns")
  }
  const [selectAnnee, setSelectAnnee] = useState("");
  const [annee, setAnnee] = useState("")
  const [etat, setEtat] = useState(2)
  useEffect(async () => {
    const resAnnee = await APIS.get("annee/select_annee_precedente").then(resAnnee =>{
      const resMastere =  APIS.post("master/fermeture_formulaire",{annee_id:resAnnee.data.Annee[0].CurrentAnnee[0].value}).then(resMastere =>{
        setEtat(resMastere.data.Master)
      })
      setSelectAnnee(resAnnee.data.Annee[0].CurrentAnnee[0].value)
      setAnnee(resAnnee.data.Annee[0].CurrentAnnee[0].label)
    })


  }, [])

  return (
    <div>
      <div
        style={{
          backgroundImage: `url(${cresusFond})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100vh",
          width: "100vw",
        }}
      >
        <div style={{ paddingTop: "15%" }}>
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card
                  style={{ backgroundColor: "#525351" }}
                  className="overflow-hidden"
                >
                  <div>
                    <Row>
                      <Col className="justify-content-center pt-4">
                        <h3
                          style={{
                            // backgroundColor: "#525351",
                            color: "#ffffff",
                            textAlign: "center",
                          }}
                        >
                          <p>CANDIDATURE MASTERE</p>
                          <p>A.U 2026/2027</p>
                        </h3>
                      </Col>
                    </Row>
                  </div>
                  {etat === 0 && (
                    <CardBody style={{ marginTop: "-20px" }} className="pt-4">
                      <div className="p-2">
                        <div className="mt-3 d-grid">
                          <button
                            onClick={inscrit}
                            style={{
                              backgroundColor: "#3ba897",
                              borderColor: "#3ba897",
                            }}
                            className="btn btn-success mb-2 me-2"
                            type="button"
                          >
                            {"Formulaire d'inscription"}
                          </button>
                        </div>

                        <div className="mt-3 d-grid">
                          <button
                            onClick={exist}
                            className="btn btn-primary btn-block"
                            type="button"
                          >
                            Déjà inscrit
                          </button>
                        </div>
                      </div>
                    </CardBody>
                  )}

                  {etat === 1 && (
                    <CardBody style={{ marginTop: "-20px" }} className="pt-4">
                      <div className="p-2">
                        <div className="mt-3 d-grid">
                          <button
                            style={{
                              backgroundColor: "#c52121",
                              borderColor: "#c52121",
                            }}
                            className="btn btn-danger mb-2 me-2"
                            type="button"
                          >
                            Oops Master est fermé
                          </button>
                        </div>
                      </div>
                    </CardBody>
                  )}

                  <div className="mt-1 text-center">
                    <p style={{ color: "white" }}>
                      © {new Date().getFullYear()} Cresus. Crafted with{" "}
                      <i className="mdi mdi-heart text-danger" /> by{" "}
                      <a style={{ color: "white" }} href="https://cresus.pro/">
                        cresus.pro
                      </a>
                    </p>
                  </div>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </div>
  )
}
export default withRouter(Redirection)
Redirection.propTypes = {
  history: PropTypes.object,
}
